module.exports = __webpack_public_path__ + "img/settings.86ccbdc8.svg";